<template>
  <v-card class="my-0">
    <v-card-title class="display-1">
      {{ title }}
    </v-card-title>
    <v-card-text>
      <highcharts :options="chartOptions" />
    </v-card-text>
  </v-card>
</template>

<script>
  import Highcharts from "highcharts";
  import HighchartsNoData from "highcharts/modules/no-data-to-display";
  HighchartsNoData(Highcharts);

  import { generateMonthlyDateRangeArray } from "@/utils/dateUtils.js";

  export default {
    name: "IndicadorSupGerByCompetenciaChart",
    props: {
      indicador: {
        type: Object,
        required: true,
      },
      competenciaDe: {
        type: String,
        required: true,
      },
      competenciaAte: {
        type: String,
        required: true,
      },
      dados: {
        type: Object,
        required: true,
      },
    },
    computed: {
      title() {
        return `${this.indicador.text} x PSP por Competência`;
      },
      competencias() {
        return generateMonthlyDateRangeArray(
          this.competenciaDe,
          this.competenciaAte,
          "YYYY-MM",
          "MM/YYYY"
        );
      },
      indicadorData() {
        return this.competencias.map((comp) => {
          const valor = this.dados[comp]?.[this.indicador.value] ?? 0;
          return typeof valor === "string" ? parseFloat(valor) : valor;
        });
      },
      pspData() {
        return this.competencias.map((comp) => {
          const valor = this.dados[comp]?.psp ?? 0;
          return typeof valor === "string" ? parseFloat(valor) : valor;
        });
      },
      chartOptions() {
        const categorias = this.competencias;

        return {
          chart: { zoomType: "x" },
          title: { text: null },
          credits: { enabled: false },
          xAxis: [{ categories: categorias, crosshair: true }],
          yAxis: [
            {
              title: { text: this.indicador.text },
              opposite: false,
            },
            {
              title: { text: "PSP (%)" },
              opposite: true,
              max: 100,
            },
          ],
          tooltip: { shared: true },
          series: [
            {
              name: this.indicador.text,
              type: "column",
              data: this.indicadorData,
              yAxis: 0,
            },
            {
              name: "PSP (%)",
              type: "spline",
              data: this.pspData,
              yAxis: 1,
              tooltip: { valueSuffix: " %" },
            },
          ],
        };
      },
    },
  };
</script>
